import InputSuffix from './input-suffix';

export default InputSuffix;
